<template>
  <transition name="fade" mode="out-in" appear>
    <div v-if="!type" key="hidden"></div>
    <div v-else-if="type === 'LOADING'" key="loading">
      <slot name="loading"><VSpinner class="offset-top-2"/></slot>
    </div>
    <VNotification v-else :key="type" v-bind="$attrs" :type="type" v-on="$listeners">
      <slot v-if="textKey" :name="type.toLowerCase()" :message="message"><span v-html="message"/></slot>
    </VNotification>
  </transition>
</template>

<script>
import VSpinner from '@/components/Spinner';
import VNotification from '@/components/Notification';

export default {
  name: 'Message',

  components: {
    VSpinner,
    VNotification,
  },

  inheritAttrs: false,

  props: {
    textKey: {
      type: [Object, String],
      required: false,
      default: null,
    },

    type: {
      type: String,
      required: true,
      validator(value) {
        return ['SUCCESS', 'WARNING', 'ERROR', 'INFO', 'LOADING'].includes(value);
      },
    },
  },

  computed: {
    message() {
      const key = this.textKey?.data?.code || this.textKey?.msg || this.textKey;
      return this.$te(`errorcodes.${key}`) ? this.$t(`errorcodes.${key}`) : this.$to(key);
    },
  },
};
</script>
